<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>{{ editorTitle }}</template>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row>
      <v-col>
        <v-text-field
          label="Client Title"
          v-model="title"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-switch label="Not In Use" v-model="notInUse"></v-switch> </v-col
    ></v-row>
    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ value }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../shared/BasicDialog";
import Contents from "../shared/contents/Contents";
export default {
  name: "edit-client-title-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },

  components: { BasicDialog, Contents },

  data() {
    return {
      debug: false,
      title: this.value ? this.value.title : "",
      notInUse: this.value ? this.value.notInUse : false,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.title != "";
    },
    editorTitle() {
      return this.title != "" ? this.title : "Edit Client Title";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.title = newVal.title;
        this.notInUse = newVal.notInUse;
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        title: this.title,
        id: this.value && this.value.id ? this.value.id : undefined,
        notInUse: this.notInUse,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/clients/EditClientTitleDialog.vue